import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import CancelPurchaseRequest from "./CancelPurchaseRequest";
import AcceptPurchaseRequest from "./AcceptPurchaseRequest";
import { trackPurchaseRequestDecisionPopupLoad } from "../../../services/analytics/OrderDetailsPageAnalytics";
import { UserContext } from "../../../context/userContext";
import DecisionIntro from "./DecisionIntro";
import { useVehicleData } from "../../../hooks/useVehicleData";

const PurchaseRequestDecision = ({ orderId }) => {
  const [decision, setDecision] = useState(null);
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  const { nameplate, modelYear } = useVehicleData(orderId);

  const handleBack = () => {
    setDecision(null);
  };

  const handleDecision = (selectedDecision) => {
    setDecision(selectedDecision);
  };

  const handleAnalyticsPageView = () => {
    trackPurchaseRequestDecisionPopupLoad(orderId, user, modelYear, nameplate);
  };

  if (decision === "accept") {
    return (
      <AcceptPurchaseRequest
        orderId={orderId}
        backButton
        handleBack={handleBack}
      />
    );
  }

  if (decision === "cancel") {
    return (
      <CancelPurchaseRequest
        orderId={orderId}
        backButton
        handleBack={handleBack}
      />
    );
  }

  return (
    <DecisionIntro
      handleDecision={handleDecision}
      text="Confirm or cancel this customer's purchase request. You can modify this later in the Pricing tab."
      primaryActionText={t("common.buttonCtas.acceptPurchaseRequest")}
      secondaryActionText={t("common.buttonCtas.cancelPurchaseRequest")}
      analyticsPageView={handleAnalyticsPageView}
    />
  );
};

PurchaseRequestDecision.propTypes = {
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default PurchaseRequestDecision;
